import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import './assets/sass/index.scss';
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const container: any = document.getElementById('root');
const root = createRoot(container);

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('G-YB2B40991W');
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider context={{}}>
          <App />
          <ToastContainer />
        </HelmetProvider>
      </Provider>
    </React.StrictMode>,
  );
} else {
  root.render(
    <Provider store={store}>
      <HelmetProvider context={{}}>
        <App />
        <ToastContainer />
      </HelmetProvider>
    </Provider>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
